import {field} from "../../../../generic/tables";
import React from "react";
import {withLinkPhone} from "../../../../../lib/utils/helpers/interfaceFeatures";
import {Col, Row, Input} from "reactstrap";
import i18next, {t} from "i18next";
import { IS_RUSSIA, LEVEL_TYPES } from '../../../../../lib/utils/constants';
import ElementWithAccessInCountries from '../../../../../lib/utils/hocs/ElementWithAccessInCountries';
import { sailingExperienceFromRuToEN } from 'sv-common/functions/formatters';

const getLevelType = (trainingCounts) => {
  if (trainingCounts <= 3) {
    return LEVEL_TYPES.beginner;
  } else if (trainingCounts >= 4 && trainingCounts <= 10) {
    return LEVEL_TYPES.experienced;
  } else {
    return LEVEL_TYPES.advanced;
  }
}

const getLevelNumberByType = (type) => {
  switch (type) {
    case LEVEL_TYPES.beginner: return 1;
    case LEVEL_TYPES.experienced: return 2;
    case LEVEL_TYPES.advanced: return 3;
    default: return 0;
  }
}

const getLevelTitle = (trainingCount) => {
  switch (getLevelType(trainingCount)) {
    case LEVEL_TYPES.beginner:
      return t('common.productOrderList.level.beginner');
    case LEVEL_TYPES.experienced:
      return t('common.productOrderList.level.experienced');
    case LEVEL_TYPES.advanced:
      return t('common.productOrderList.level.advanced');
    default:
      return '';
  }
}

export const getLevelBadges = (sailing_experience, trainingCounts = 0) => {
  const exp_rate = [];
  let level;
  let total;

  if (IS_RUSSIA) {
    [level, total] = sailing_experience?.split('/') || [0, 7];
  } else {
    if (sailing_experience) {
      [level, total] = sailingExperienceFromRuToEN(sailing_experience)?.split('/') || [1, 3];
    } else {
      level = getLevelNumberByType(getLevelType(trainingCounts));
      total = 3;
    }
  }

  for (let i = 0; i < total; i++) {
    exp_rate.push(<div key={i}
                       className={`d-inline badge badge${i < level ? '' : '-outline'}-success experience-badge `}/>)
  }

  return <Row><Col>{exp_rate.map(badge => badge)}</Col></Row>
}

export const getSlotSet = ({instructorsArray, onChangeInstructors} = {}) => {
  const { language } = i18next;

  const fields = [
    field(t('common.productOrderList.name'), false, "client_id.first_name", res => res.client_id?.first_name),
    field(t('common.productOrderList.lastname'), false, "client_id.last_name", res => res.client_id?.last_name),
    field(t('common.productOrderList.phone'), false, "client_id.phone", res =>
      withLinkPhone(res.contact_phone || res.client_id?.phone, 'phone')
    ),
  ];

  if (IS_RUSSIA && instructorsArray) {
    fields.push(field(t('common.productOrderList.instructor'), false, "instructor_id", res => {
      if (!instructorsArray || !instructorsArray?.length > 0) return

      return <>
        <Input type={'select'} name={'instructor_id'} defaultValue={'any'} onChange={(value) => onChangeInstructors(value.target.value, res.id, res.paid_for_length)}>
                <option value={''}>{t('management.orders.customFormControls.anyoneCool')}</option>
                {
                  instructorsArray
                  .filter((instructor) => res.instructor_id.id !== instructor.id)
                  .map((instructor, i) =>
                    <option
                      disabled={instructor.available_sits < res.paid_for_length && res.instructor_id?.id !== instructor.id}
                      value={instructor.id}>
                      {
                        instructor.first_name
                      } {
                      instructor.last_name
                    } | {t('management.orders.customFormControls.places')}: {
                      instructor.available_sits + ' / ' + instructor.total_sits
                    }
                    </option>)
                }
        </Input>
      </>
    }));
  } else if (IS_RUSSIA) {
      fields.push(field(t('common.productOrderList.instructor'), false, "instructor_id", res => {
        if (res.coachless_discount_applied)
          return t('common.productOrderList.withoutInstructor')
        if (!res.instructor_id)
          return t('common.productOrderList.anyInstructor')
      return <>{`${res.instructor_id?.first_name || ''} ${res.instructor_id?.last_name || ''}`}</>
    }));
  }

  fields.push(
    field(t('common.productOrderList.count'), false, "paid_for_length"),
    field(t('common.productOrderList.experience'), false, "client_id.sailing_experience", res => <div className={`experience-block-${language}`}>
        {getLevelBadges(res.client_id?.sailing_experience, res.client_id?.slots_visited || 0)}
        <ElementWithAccessInCountries hideInCountries={['EN']}>
          <hr className={'experience-divider'}/>
        </ElementWithAccessInCountries>
        <Row>
          <Col>
            Σ: {res.client_id?.slots_visited || '0'} <ElementWithAccessInCountries hideInCountries={['RU']}><>- {getLevelTitle(res.client_id?.slots_visited || 0)}</></ElementWithAccessInCountries>
          </Col>
        </Row>
      </div>
    ),
    field(t('common.productOrderList.comment'), false, "comment", res =>
      <>
        {
          res?.comment?.match(/.{1,50}/g)
            ?.map(line => <div>{line}</div>)
        }
      </>),
    field(t('common.productOrderList.email'), false, "client_id.email", res => res.client_id?.email))

  return fields;
}